<template>
<div
    class="test-show-form"
    :class="{
        'dark': !isPublicForm,
    }"
>
    <test-page-header
        :title="testBeingPassing.name"
        :return-button="returnButton"
        :is-show-navigation="!isPublicForm"
    />

    <div class="text-question-answer-form-container">
        <test-question-answer-form
            :question="questionBeingPassing"
        />
        <div class="test-question-answer-form-footer">
            <button class="button is-link" @click="sendAnswerAndContinue" :disabled="!isCompleteQuestionBeingPassing">
                {{ trans.show_form.send_answer_button }}
            </button>

            <button class="button ml-1" v-if="isCanSkip" @click="skipAnswerAndContinue">
                {{ trans.show_form.skip }}
            </button>

            <span class="ml-auto test-questions-left-counter">
               {{ questionsLeftLabel }}
            </span>
        </div>
        <div class="error-message mt-1" v-if="failMessage">
            {{ failMessage }}
        </div>
    </div>
</div>
</template>

<script>
import TestQuestionAnswerForm from "./TestQuestionAnswerForm";
import {mapActions, mapGetters} from "vuex";
import TestPageHeader from "../TestPageHeader";

export default {
name: "TestShowForm",
    components: {TestPageHeader, TestQuestionAnswerForm},
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('tests', [
            'questionBeingPassing',
            'trans',
            'testBeingPassing',
            'testTaker',
            'failMessage',
            'isPublicForm',
            'isCompleteQuestionBeingPassing',
        ]),
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnButtonHandler,
            }
        },
        questionsLeft() {
            return this.testTaker.session.stat.total - this.testTaker.session.stat.answered;
        },

        questionsLeftLabel() {
            return this.replaceWildcards(this.trans.show_form.questions_left_label, {
                count: this.questionsLeft,
            })
        },
        isCanSkip() {
            return !this.questionBeingPassing.settings.is_required;
        }
    },
    methods: {
        ...mapActions('tests', [
            'sendAnswerAndContinue',
            'returnToTestListPage',
            'skipAnswerAndContinue',
        ]),
        returnButtonHandler() {
            return this.returnToTestListPage();
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables';
.test-show-form {
    padding: 0 25px;
    &.dark {
        background: #E5E5E5;
    }
}
.text-question-answer-form-container {
    border-radius: 6px;
    background: $white;
    padding: 20px 45px 55px 20px;

    .error-message {
        font-size: 1rem;
        color: $danger;
    }
}
.test-question-answer-form-footer {
    margin-top: 30px;
    display: flex;

    .test-questions-left-counter {
        align-self: center;
        color: $tests-grey;
    }
}
</style>